import { REACT_APP_VMS_BASE_URL } from "../utils/urls";

const fetchVisitsAll = async (site_id: any) => {
  const result = await fetch(`${REACT_APP_VMS_BASE_URL}/visits/${site_id}/all`);
  const visits = await result.json();
  return visits;
};

export default fetchVisitsAll;
